import React, { FC, useEffect } from 'react'
import { Language, LanguageDictionary } from '../language'
import imageMapResize from 'image-map-resizer'

import BannerImageEn  from './ImageBannerEn.png'
import BannerImageFr  from './ImageBannerFr.png'

const bannerImage: LanguageDictionary<string> = {
	English: BannerImageEn,
	French: BannerImageFr,
}

const bannerAltText: LanguageDictionary<string> = {
	English: 'Banner introducing the 5th edition workbook', 
	French: 'Bannière présentant le 5e édition du manuel de l’atelier', 
}

const bannerLink: LanguageDictionary<string> = {
	English: 'https://www.ontariosoilcrop.org/wp-content/uploads/2025/07/5th-Edition-EFP-FAQs.pdf', 
	French: 'https://www.ontariosoilcrop.org/wp-content/uploads/2025/07/5th-Edition-EFP-FAQs-FR.pdf'
}

const bannerClickRectCoords: LanguageDictionary<string> = {
	English: '1470, 351, 1918, 563',
	French: '1471, 350, 1918, 598'
}

export interface ImageBannerProps {
	language: Language
}

export const ImageBanner: FC<ImageBannerProps> = ({ language }) => {
	useEffect(() => {
		// Supports image maps for images that vary with screen size
		imageMapResize();
	}, []);

	return (
		<div className='image-banner'>
			<img src={bannerImage[language]} alt={bannerAltText[language]} useMap='#image-banner-map' />
			<map name='image-banner-map'>
				<area shape="rect" coords={bannerClickRectCoords[language]} href={bannerLink[language]} target='_blank' />
			</map>
		</div>
	)
}